
export class VisitorDto {

    id:number;
    requestId: number;
    visitorName: any;
    visitorCard: string;
    checkIn: Date;
    checkOut: Date;
    isActive: boolean;
    createdAt: Date;
    createdUser: string;
    updatedAt: Date;
    updatedUser: string;
    versionFlag: number;

    constructor(id:number,requestId: number,visitorName: any,visitorCard: string,checkIn: Date,checkOut: Date,isActive: boolean,
        createdAt: Date,createdUser: string,updatedAt: Date,updatedUser: string,versionFlag: number){
            this.id =id;
            this.requestId = requestId;
            this.visitorName = visitorName;
            this.visitorCard = visitorCard;
            this.checkIn = checkIn;
            this.checkOut = checkOut;
            this.isActive = isActive;
            this.createdAt = createdAt;
            this.createdUser = createdUser;
            this.updatedAt = updatedAt;
            this.updatedUser = updatedUser;
            this.versionFlag = versionFlag;

    }
}